export class TenantsContactModel {
    public Id: number = 0;
    public FirstName: string;
    public LastName: string;
    public PhoneNumber: string;
    public MobileNumber: string;
    public EmailAddress: string;

    public TenantContactId: number = 0;
    public TenantId: number = 0;
    public ContactId: number = 0;
    public JobTypeId: number = 0;
    public JobTitle: string;
    public FullName: string;
    public JobTypeName: string;
    public IsActive = true
}



// WEBPACK FOOTER //
// ./src/app/models/tenantContactModel.ts